export default function ComparisonSection() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            Why Choose Vigorbuy Spreadsheet?
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
            Traditional Search vs Vigorbuy Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            See how our organized approach makes product discovery faster and easier
          </p>
        </div>

        <div className="overflow-hidden rounded-lg border border-background-200">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-200/60">
                <th className="px-6 py-4 text-left font-semibold text-foreground-900 w-1/3">Feature</th>
                <th className="px-6 py-4 text-left font-semibold text-foreground-600">Traditional Search</th>
                <th className="px-6 py-4 text-left font-semibold text-primary-600">Vigorbuy Spreadsheet</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-background-200">
              <tr className="bg-background-50">
                <td className="px-6 py-4 font-medium text-foreground-800">Finding Products</td>
                <td className="px-6 py-4 text-foreground-500">Slow, scattered results</td>
                <td className="px-6 py-4 text-primary-600 font-medium">Fast, organized discovery</td>
              </tr>
              <tr className="bg-background-50">
                <td className="px-6 py-4 font-medium text-foreground-800">Organization</td>
                <td className="px-6 py-4 text-foreground-500">Poor, no structure</td>
                <td className="px-6 py-4 text-primary-600 font-medium">Structured, filterable</td>
              </tr>
              <tr className="bg-background-50">
                <td className="px-6 py-4 font-medium text-foreground-800">Product Comparison</td>
                <td className="px-6 py-4 text-foreground-500">Limited, manual</td>
                <td className="px-6 py-4 text-primary-600 font-medium">Easy, side-by-side</td>
              </tr>
              <tr className="bg-background-50">
                <td className="px-6 py-4 font-medium text-foreground-800">Category Coverage</td>
                <td className="px-6 py-4 text-foreground-500">Incomplete</td>
                <td className="px-6 py-4 text-primary-600 font-medium">Comprehensive, 14 categories</td>
              </tr>
              <tr className="bg-background-50">
                <td className="px-6 py-4 font-medium text-foreground-800">Beginner Experience</td>
                <td className="px-6 py-4 text-foreground-500">Difficult, confusing</td>
                <td className="px-6 py-4 text-primary-600 font-medium">Simple, guided</td>
              </tr>
              <tr className="bg-background-50">
                <td className="px-6 py-4 font-medium text-foreground-800">Data Updates</td>
                <td className="px-6 py-4 text-foreground-500">Unknown, outdated</td>
                <td className="px-6 py-4 text-primary-600 font-medium">Regularly refreshed</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}